import axios from 'axios';

const BASE_URL = 'https://pixabay.com/api/';
const API_KEY = '54232981-c31f974ffcf6297d84a7e0e1d';

export function getImagesByQuery(query) {
  return axios
    .get(BASE_URL, {
      params: {
        key: API_KEY,
        q: query,
        image_type: 'photo',
        orientation: 'horizontal',
        safesearch: true,
      },
    })
    .then(response => {
      return response.data;
    });
}
